import ZwxScrollbarY from './Index.vue'


ZwxScrollbarY.install = function(Vue) {
  Vue.component(ZwxScrollbarY.name, ZwxScrollbarY)
}

export default ZwxScrollbarY
